(function() { window.GUID_4f81fe66_20f1_4acd_83ee_cb41d20bba53 = { getGuid: function() { return "4f81fe66-20f1-4acd-83ee-cb41d20bba53"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let EncountersFormat;
        (function (EncountersFormat) {
            EncountersFormat[EncountersFormat["Cards"] = 0] = "Cards";
            EncountersFormat[EncountersFormat["Table"] = 1] = "Table";
            EncountersFormat[EncountersFormat["BergerByNumber"] = 2] = "BergerByNumber";
            EncountersFormat[EncountersFormat["BergerByName"] = 3] = "BergerByName";
        })(EncountersFormat = Enumeration.EncountersFormat || (Enumeration.EncountersFormat = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=EncountersFormat.pre.js.map
